import React, { useEffect, useRef, useState } from "react";
import { Box, IconButton, ThemeProvider, Typography } from "@mui/material";

import { MuiTheme } from "../styles/MuiDataTableStyle";
import encode from "jwt-encode";
import { useLocation } from "react-router-dom";
import { ArrowBack, InsertChartOutlinedRounded } from "@mui/icons-material";
import { getAllReports } from "../services/reportsService";
import { useStateAuthValue } from "../context/AuthState";
import { showToast, ToastType } from "../utils/ToastUtil";
import { useToast } from "../context/Toast/ToastProvider";
import DelinquentPartners from "./delinquentPartners";

const GenericDashboard = ({
  buttonsList = [
    { label: "label", reportName: "reportName", active: false, params: {} },
  ],
  title,
  extraViews = [],
}) => {
  const [isShowingDashboard, setisShowingDashboard] = useState(true);
  //const [{ reports }] = useStateReportValue();
  const [reports, setReports] = useState([]);
  const [url, setUrl] = useState("");
  const [currentView, setcurrentView] = useState(null);
  const [{ userToken }] = useStateAuthValue();
  const toastDispatch = useToast();
  const location = useLocation();

  const embeber = (token, dashboard, _params) => {
    const payload = {
      resource: { dashboard: dashboard },
      params: _params,
      exp: Math.round(Date.now() / 1000) + 120 /*minutos*/ * 60 /*segundos*/,
    };
    const tokenJWT = encode(payload, token);
    const url =
      process.env.REACT_APP_API_URL +
      `/embed/dashboard/${tokenJWT}#bordered=true&titled=true`;
    return url;
  };
  const displayError = (msg) =>
    showToast(toastDispatch, msg, ToastType.ERROR, ToastType.ERROR);
  useEffect(() => {
    GetReports();
  }, []);

  useEffect(() => {
    if (reports?.length) {
      GetLocation();
    }
  }, [reports]);

  // Al navegar a otro dashboard (cambia el path), volver al listado de botones.
  // Sin esto, React reutiliza la instancia del componente y conserva el reporte
  // que se estaba viendo en el dashboard anterior.
  useEffect(() => {
    setcurrentView(null);
    setUrl("");
    setisShowingDashboard(true);
  }, [location.pathname]);

  const GetReports = async () => {
    return await getAllReports(userToken, displayError).then((reportsGet) => {
      setReports(reportsGet);
    });
  };
  const GetLocation = () => {
    const urlParams = new URLSearchParams(window.location.search);

    // Obtener el valor del parámetro "param"
    const _currentView = urlParams.get("current-view");
    setcurrentView(_currentView);
    if (_currentView) {
      let report = reports.find((element) => element.name === _currentView);
      if (report) {
        let button = buttonsList.find((b) => b.reportName === _currentView);
        if (button) {
          setUrl(embeber(report.secrey_key, parseInt(report.remote_id, 10), button.params ? button.params : {}));
        } else {
          setUrl(embeber(report.secrey_key, parseInt(report.remote_id, 10)));
        }
      }
    }
  };
  const miRef = useRef(null);

  const centrarComponente = () => {
    miRef.current.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center",
    });
  };

  const handleChangeView = (viewName, params) => {
    setisShowingDashboard(false);
    // Crear una instancia del objeto URL basado en la URL actual
    const url = new URL(window.location);

    // Agregar o actualizar el parámetro
    url.searchParams.set("current-view", viewName);

    // Actualizar la URL en el navegador sin recargar la página
    window.history.pushState({}, "", url);
    setcurrentView(viewName);
    let report = reports?.find((element) => element.name === viewName);
    if (report) {
      GetLocation();
      setUrl(
        embeber(
          report.secrey_key,
          parseInt(report.remote_id, 10),
          params ? params : {},
        ),
      );
      setTimeout(() => {
        centrarComponente();
      }, 100);
    }
  };
  const handleBack = () => {
    // Limpiar el parámetro current-view de la URL y volver al listado
    const backUrl = new URL(window.location);
    backUrl.search = "";
    window.history.replaceState({}, "", backUrl);
    setcurrentView(null);
    setUrl("");
    setisShowingDashboard(true);
  };

  const normalButtons = buttonsList.filter((b) => b.newRow !== true);
  const newRowButtons = buttonsList.filter((b) => b.newRow === true);

  const renderReportButton = (b) => {
    const disabled = b.active === false;
    const isNewRow = b.newRow === true;

    return (
      <Box
        key={b.reportName}
        onClick={() => {
          if (disabled) return;
          handleChangeView(b.reportName, b.params);
        }}
        sx={{
          width: 210,
          minHeight: 160,
          background: disabled ? "#f5f5f5" : isNewRow ? "#eef9ff" : "#ffffff",
          border: isNewRow ? "1px solid #39a9db" : "1px solid #ebebeb",
          borderRadius: "14px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "0.9rem",
          padding: "1.5rem 1rem",
          textAlign: "center",
          marginTop: isNewRow ? "0.5rem" : 0,
          cursor: disabled ? "default" : "pointer",
          opacity: disabled ? 0.65 : 1,
          transition: "0.2s ease-in-out all",
          "&:hover": disabled
            ? {}
            : {
                transform: "translateY(-4px)",
                boxShadow: "0 12px 24px rgba(0,0,0,0.10)",
                borderColor: isNewRow ? "#2c94c2" : "#002C54",
                "& .report-card-chip": {
                  background: isNewRow
                    ? "linear-gradient(195deg, #39a9db, #2c94c2)"
                    : "linear-gradient(195deg, #002C54, #003f77)",
                  color: "#ffffff",
                },
              },
        }}
      >
        <Box
          className="report-card-chip"
          sx={{
            width: 52,
            height: 52,
            borderRadius: "12px",
            background: isNewRow ? "rgba(57,169,219,0.2)" : "rgba(0,44,84,0.1)",
            color: isNewRow ? "#1f7295" : "#002C54",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "0.2s ease-in-out all",
          }}
        >
          <InsertChartOutlinedRounded />
        </Box>
        <Typography
          sx={{
            fontSize: "0.95rem",
            fontWeight: 700,
            color: disabled ? "#9e9e9e" : isNewRow ? "#1f7295" : "#002C54",
            lineHeight: 1.25,
          }}
        >
          {b.label}
        </Typography>
      </Box>
    );
  };

  const renderView = () => {
    if (!currentView) return null;

    if (currentView=== "CarteraMorosa") return <DelinquentPartners></DelinquentPartners>;

    // Si está en extraViews, renderiza eso
    if (extraViews[currentView]) {
      return extraViews[currentView];
    }

    // Si no, renderiza el genérico
    return (
      <div className="report" ref={miRef}>
        <iframe
          src={url}
          className="iframe-report"
          frameBorder="0"
          width="100%"
          height="100%"
          allowtransparency="true"
        ></iframe>
      </div>
    );
  };

  return (
    <ThemeProvider theme={MuiTheme}>
      <div
        className="users-table-container"
        style={{ padding: "2.5rem", position: "relative", alignItems: "stretch" }}
      >
        {/* Header banner de marca (azul) */}
        <Box
          key={"header"}
          sx={{
            background: "linear-gradient(195deg, #002C54, #003f77)",
            borderRadius: "15px",
            color: "white",
            padding: "1.75rem 2rem",
            boxShadow: "0 8px 24px rgba(0,44,84,0.25)",
            display: "flex",
            alignItems: "center",
            gap: "1.1rem",
            marginBottom: "2rem",
          }}
        >
          {currentView != null && (
            <IconButton
              aria-label="volver"
              onClick={handleBack}
              sx={{
                color: "white",
                backgroundColor: "rgba(255,255,255,0.12)",
                transition: "0.2s ease-in-out all",
                "&:hover": { backgroundColor: "rgba(255,255,255,0.22)" },
              }}
            >
              <ArrowBack />
            </IconButton>
          )}
          <Box>
            <Typography
              sx={{ fontSize: "22px", fontWeight: 700, letterSpacing: "0.5px" }}
            >
              {currentView=== "CarteraMorosa" ? "Cartera Morosa" : title}
            </Typography>
            {currentView!== "CarteraMorosa" && (
               <Typography sx={{ fontSize: "13px", fontWeight: 400, opacity: 0.8 }}>
              {currentView != null
                ? "Visualizando reporte"
                : "Seleccioná un reporte para visualizar"}
            </Typography>
            )}
          
          </Box>
        </Box>

        {!currentView ? (
          <Box
            key={"grid"}
            sx={{
              display: "flex",
              justifyContent: "center",
              padding: "1rem 0 2rem",
            }}
          >
            <Box
              sx={{
                width: "fit-content",
                maxWidth: "100%",
                margin: "0 auto",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "stretch",
                  flexWrap: "wrap",
                  gap: "1.5rem",
                }}
              >
                {normalButtons.map((b) => renderReportButton(b))}
              </Box>

              {newRowButtons.length > 0 && (
                <Box
                  sx={{
                    marginTop: "1.5rem",
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "stretch",
                    flexWrap: "wrap",
                    gap: "1.5rem",
                  }}
                >
                  {newRowButtons.map((b) => renderReportButton(b))}
                </Box>
              )}
            </Box>
          </Box>
        ) : (
          renderView()
        )}
      </div>
    </ThemeProvider>
  );
};

export default GenericDashboard;
